import { Component, OnInit, ViewChild } from "@angular/core";
import { ConfirmationService } from "primeng/primeng";
import { GlobalAppService } from "../../../../core/commons/global-app.service";
import { Router } from "@angular/router";
import { MessageSeverity } from "../../../../core/commons/message-severity";
import { Ministry } from "../../../../profile/domain/ministry/ministry";
import { MinistryService } from "../../../../profile/service/ministry.service";
import { MatSort, MatPaginator, MatTableDataSource } from "@angular/material";
import { QueryOptions } from "../../../../core/commons/query.options";
import { FormBuilder, FormControl, FormGroup } from "@angular/forms";

@Component({
  selector: "app-ministry-list",
  templateUrl: "./ministry-list.component.html",
  styleUrls: ["./ministry-list.component.scss"]
})
export class MinistryListComponent implements OnInit {
  ministries = new MatTableDataSource([]);
  queryOptions: QueryOptions;
  resultsLength: number;
  ministryData: any = {};

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  displayedColumns = ["name", "address", "city", "acciones"];
  formGroup: FormGroup;

  constructor(
    private ministryService: MinistryService,
    private confirmationService: ConfirmationService,
    private appService: GlobalAppService,
    private router: Router,
    private fb: FormBuilder
  ) {}

  ngOnInit() {
    this.formGroup = this.fb.group({
      search: new FormControl("")
    });

    this.queryOptions = new QueryOptions();
    this.queryOptions.size = 5;
    this.applyFilter();

    this.paginator.page.subscribe(() => {
      this.queryOptions.page = this.paginator.pageIndex;
      this.queryOptions.size = this.paginator.pageSize;
      this.applyFilter();
    });

    this.formGroup.controls["search"].valueChanges
      .debounceTime(400)
      .subscribe(() => this.applyFilterAndReset());
  }

  applyFilterAndReset() {
    this.paginator.pageIndex = 0;
    this.queryOptions.size = 5;
    this.queryOptions.page = 0;
    this.applyFilter();
  }

  applyFilter() {
    this.ministryService
      .pagedSearch(this.formGroup.controls["search"].value, this.queryOptions)
      .subscribe(data => {
        this.ministryData = data;
        this.ministries.data = this.ministryData.content;
        this.resultsLength = this.ministryData.totalElements;
      });
  }

  public gotoDetail(ministry: Ministry) {
    this.router.navigate(["home", "ministry", ministry.id]);
  }

  public addMinistry() {
    this.router.navigate(["home", "ministry", "new"]);
  }

  public deleteMinistry(ministry: Ministry) {
    this.confirmationService.confirm({
      message: "¿está seguro que desea eliminar el ministerio?",
      icon: "fa ui-icon-delete-forever",
      accept: () => {
        this.appService.setLoading(true);
        this.ministryService.delete(ministry).subscribe(
          b => {
            this.appService.setLoading(false);
            this.applyFilter();
            this.appService.sendMsg(
              MessageSeverity.SUCCESS,
              "Eliminado",
              "Se ha eliminado el ministerio."
            );
          },
          error => {
            this.appService.setLoading(false);
            this.appService.sendMsg(
              MessageSeverity.ERROR,
              "Error",
              "No ha sido posible eliminar el ministerio. " +
                error.json().message
            );
          }
        );
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/fiscalia/component/ministries/ministry-list/ministry-list.component.ts